export const ADMIN_ACCESS: number = 1;
export const REPORTS: number = 2;
export const JOURNALING: number = 3;
export const PASSENGERS_ACCESS: number = 4;
export const PASSENGERS_SETTINGS_ACCESS: number = 5;
export const CATALOG_SETTINGS_ACCESS: number = 6;
export const VIDEO_SETTINGS_ACCESS: number = 7;
//export const VIDEO: number = 8;
export const MAP: number = 9;
export const CATALOG_ACCESS: number = 10;
export const EVENTS: number = 11;
export const EXTERNAL_ACCESS: number = 12;
export const CATALOG_ACCESS_READONLY: number = 13;
export const DRIVER_SETTINGS_ACCESS: number = 14;
export const CATALOG_DELETE_ACCESS: number = 15;
//export const CATALOG_EDIT_ACCESS: number = 16;
export const NAVIGATION_SETTINGS_ACCESS: number = 17;
export const REPORTS_SETTINGS_ACCESS: number = 18;
export const JOURNALS_SETTINGS_ACCESS: number = 19;

export const USER_ADD_ACCESS: number = 20;
export const USER_DELETE_ACCESS: number = 21;
export const USER_VIEW_ACCESS: number = 22;

export const VIDEO_ADD_ACCESS: number = 23;
export const VIDEO_DELETE_ACCESS: number = 24;
export const VIDEO_VIEW_ACCESS: number = 25;

export const AUTO_REPORTS: number = 26;
export const VIDEO_DELETE_MY_ACCESS: number = 27;

export const VEHICLE_DIAGNOSTIC_ACCESS: number = 28;

export const BC_SETTINGS_ACCESS = 29;
export const BC_RESULT_ACCESS = 30;
export const BC_ACCESS = 31;

export const REMOTE_UPDATE_ACCESS = 32;
export const TICKETS_VALIDATION_ACCESS = 33;

export const ADAS_ACCESS = 34;

export const PDM_VIEW_ACCESS = 35;
export const PDM_TREE_UPDATE_ACCESS = 36;
export const PDM_HEAT_MAP_ACCESS = 37;
export const PDM_VEHICLE_EQUIPMENT_MONITORING_ACCESS = 38;
export const PDM_NODE_CHANGE_JOURNAL_ACCESS = 39;
export const PDM_GRAPH_REPORTS_ACCESS = 40;
export const PDM_SERVICE_REPORTS_ACCESS = 41;
export const PDM_IMPORT_MANAGER_ACCESS = 42;
export const PDM_EQUIPMENT_STATUS_REPORT_ACCESS = 43;

export const permissionsCode: { [key: string]: string } = {
  [ADMIN_ACCESS]: 'Администрирование',
  [MAP]: 'Просмотр данных на карте',
  //  [VIDEO]: 'Доступ к подсистеме "Видео"',
  [PASSENGERS_ACCESS]: 'Доступ к подсистеме "Пассажиропоток"',
  // [EVENTS]: 'Доступ к подсистеме "Контроль качества вождения"',
  [CATALOG_ACCESS]: 'Добавление/редактирование данных в справочниках',
  // [CATALOG_EDIT_ACCESS]: "Редактирование данных в справочниках",
  [CATALOG_DELETE_ACCESS]: 'Удаление данных из справочников',
  [CATALOG_ACCESS_READONLY]: 'Просмотр справочников',
  // [REPORTS]: 'Доступ к подсистеме "Отчеты"',
  [JOURNALING]: 'Доступ к подсистеме "Журналирование"',

  [PASSENGERS_SETTINGS_ACCESS]:
    'Доступ к настройкам подсистемы "Пассажиропоток"',
  [CATALOG_SETTINGS_ACCESS]: 'Доступ к настройкам справочников',
  [VIDEO_SETTINGS_ACCESS]: 'Доступ к настройкам подсистемы "Видео"',
  [NAVIGATION_SETTINGS_ACCESS]: 'Доступ к настройкам подсистемы "Навигация"',
  // [REPORTS_SETTINGS_ACCESS]: 'Доступ к настройкам подсистемы "Отчеты"',
  [JOURNALS_SETTINGS_ACCESS]: 'Доступ к настройкам подсистемы "Журналы"',
  [BC_SETTINGS_ACCESS]: 'Доступ к настройкам билетного контроля',
  // [EXTERNAL_ACCESS]: "Интеграционный клиент",
  [USER_ADD_ACCESS]: 'Добавление/редактирование пользователей и ролей',
  [USER_DELETE_ACCESS]: 'Удаление пользователей и ролей',
  [USER_VIEW_ACCESS]: 'Просмотр пользователей и ролей',
  [VIDEO_ADD_ACCESS]: 'Добавление/редактирование видео',
  [VIDEO_DELETE_ACCESS]: 'Удаление заявок в Архиве видео',
  [VIDEO_DELETE_MY_ACCESS]: 'Удаление заявок в Мои заявки',
  [VIDEO_VIEW_ACCESS]: 'Просмотр видео',
  [VEHICLE_DIAGNOSTIC_ACCESS]: 'Просмотр мониторинга бортового оборудования',
  [BC_RESULT_ACCESS]: 'Результаты ПБК',
  [BC_ACCESS]: 'ПБК',
  [REMOTE_UPDATE_ACCESS]: 'Конфигурации МНТ',
  [TICKETS_VALIDATION_ACCESS]: 'Импорт данных о валидациях проездных билетов',
  [ADAS_ACCESS]: 'Доступ к отчетам ИСПВ',
  [PDM_VIEW_ACCESS]: 'Просмотр данных ПДМ',
  [PDM_TREE_UPDATE_ACCESS]: 'Добавление/редактирование уникальных деревьев датчиков',
  [PDM_HEAT_MAP_ACCESS]: 'Тепловая карта',
  [PDM_VEHICLE_EQUIPMENT_MONITORING_ACCESS]: 'Мониторинг состояния БО',
  [PDM_NODE_CHANGE_JOURNAL_ACCESS]: 'Журнал изменений состояния узла',
  [PDM_GRAPH_REPORTS_ACCESS]: 'Графические отчёты',
  [PDM_SERVICE_REPORTS_ACCESS]: 'Сервисные отчеты',
  [PDM_IMPORT_MANAGER_ACCESS]: 'Доступ к менеджеру импорта отчётов',
  [PDM_EQUIPMENT_STATUS_REPORT_ACCESS]: 'Доступ к отчёту о состоянии БО за период',
  // [AUTO_REPORTS]: "Рассылка автоматических отчетов"
  // [PASSENGERS_REPORTS]: 'Доступ к отчетам подсистемы "Анализ пассажиропотоков"',
};
